import React from 'react';
import { Box, Typography } from '@mui/material';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

const TimelineDaySnapshotCard = ({
  daySnapshot = null,
  embedded = false,
}) => {
  if (!daySnapshot?.text) {
    return null;
  }

  return (
    <Box
      sx={{
        px: embedded ? { xs: 0.1, md: 0.2 } : { xs: 0.1, md: 0.35 },
        mb: embedded ? 0.8 : 1.15,
      }}
    >
      <Box
        sx={{
          p: embedded ? { xs: 1.05, md: 1.15 } : { xs: 1.15, md: 1.25 },
          borderRadius: embedded ? '16px' : '18px',
          border: `1px solid ${alpha(colors.semantic.sageDeep, embedded ? 0.18 : 0.24)}`,
          background: embedded
            ? `linear-gradient(180deg, ${alpha(colors.semantic.sageSoft, 0.84)} 0%, ${alpha(colors.landing.surface, 0.96)} 100%)`
            : `linear-gradient(180deg, ${alpha(colors.semantic.sageSoft, 0.95)} 0%, ${alpha(colors.landing.surface, 1)} 100%)`,
          boxShadow: 'none',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: `linear-gradient(90deg, ${alpha(colors.semantic.sageDeep, 0.07)} 0%, transparent 38%)`,
            pointerEvents: 'none',
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.75 }}>
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: '10px',
              bgcolor: alpha(colors.semantic.sageDeep, 0.14),
              color: colors.semantic.sageDeep,
              display: 'grid',
              placeItems: 'center',
              flexShrink: 0,
              boxShadow: `inset 0 0 0 1px ${alpha(colors.semantic.sageDeep, 0.08)}`,
            }}
          >
            <AutoAwesomeRoundedIcon sx={{ fontSize: 16 }} />
          </Box>
          <Typography
            sx={{
              fontSize: '0.7rem',
              fontWeight: 900,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: colors.semantic.sageDeep,
              lineHeight: 1,
            }}
          >
            {daySnapshot.label || 'Day snapshot'}
          </Typography>
        </Box>

        <Typography
          sx={{
            position: 'relative',
            zIndex: 1,
            fontSize: embedded ? { xs: '0.88rem', sm: '0.92rem' } : { xs: '0.94rem', sm: '0.98rem' },
            lineHeight: 1.44,
            color: colors.semantic.ink,
            fontWeight: 400,
            maxWidth: embedded ? 680 : 760,
            textWrap: 'balance',
          }}
        >
          {daySnapshot.text}
        </Typography>
      </Box>
    </Box>
  );
};

export default TimelineDaySnapshotCard;
